export default __webpack_public_path__ + "static/media/success-icon.1b6082f8.svg";